const loginAndSignUp = {
  loginTips: "Sudah punya akun HitPaw? <1>Masuk</1>",
  loginSuccessTips: "Berhasil masuk",
  loginErrorTips: "Gagal masuk",
  loginAccountOrPasswordErrorTips: "Alamat email atau kata sandi Anda salah. Silakan coba lagi.",
  loginAccountNotExitErrorTips: "Email tidak terdaftar",
  signUpTips: "Belum terdaftar sebagai pengguna?",
  rememberMe: "Ingat saya",
  forgotPassword: "Lupa kata sandi?",
  forgotPasswordTitle: "Lupa kata sandi",
  verifyEmailBtn: "Verifikasi Email",
  resetPasswordTitle: "Setel ulang kata sandi",
  resetPasswordLabel: "Silakan atur ulang kata sandi Anda",
  resetPasswordPlaceholder: "Masukan kata sandi yang baru",
  resetPasswordSuccessTips: "Reset kata sandi berhasil",
  signUpPrivacyTips: "Dengan mendaftar, Anda menyetujui <1>Layanan Penggunaan</1> dan <3>Kebijakan Privasi</3> kami",
  loginPrivacyTips: "Dengan masuk, Anda menyetujui <1>Layanan Penggunaan</1> dan <3>Kebijakan Privasi</3> kami",
  signUpSuccessTips: "Akun Anda Telah Berhasil Terdaftar！",
  getCode: "Dapatkan Kode",
  getCodeSuccessTips: "Sudah terkirim ke mailbox anda, silahkan dicek",
  verificationSuccessTips: "Verifikasi alamat email berhasil",
  surveyTitle: "Selamat datang di HitPaw Online",
  surveyStep1: "<1>Langkah 1</1>/3",
  surveyStep2: "<1>Langkah 2</1>/3",
  surveyStep3: "<1>Langkah 3</1>/3",
  surveyQuestion: "Apa tujuan Anda menggunakan HitPaw?",
  surveyThemeQuestion: "Pilih mode yang Anda suka",
  surveyAnswerOther: "Lainnya",
  surveyAnswer1: "Video Gaya Hidup",
  surveyAnswer2: "Video Bisnis",
  surveyAnswer3: "Video Perusahaan",
  surveyAnswer4: "Video Pemasaran",
  surveyAnswer5: "Video Media Sosial",
  surveyAnswer6: "Video Slideshow",
  surveyAnswer7: "Alat Video",
  surveyAnswer8: "Video Perjalanan",
  surveyAnswer9: "Video Pernikahan",
  surveyAnswer10: "Video Ulang Tahun",
  surveyAnswer11: "Video Bayi",
  surveyAnswer12: "Video Hewan",
  surveyAnswer13: "Video Makanan",
  surveyAnswer14: "Video Mode",
  surveyAnswer15: "Video Liburan",
  surveyAnswer16: "Video Olahraga",
  surveyAnswer17: "Video Fotografi",
  surveyAnswer18: "Video Musik",
  surveyAnswerLightMode: "Mode terang",
  surveyAnswerDarkMode: "Mode gelap",
  surveyNextBtn: "Selanjutnya",
  surveyBackBtn: "Kembali",
  surveyDoneBtn: "Selesai",
  surveyStartBtn: "Mulai",
  logoutWarnTips: "Apakah Anda yakin untuk keluar?",
  ContinuewithGoogle: 'Lanjutkan dengan Google',
  Securityverification: 'Verifikasi keamanan',
  youraccount: 'akun Anda',
  alreadyexiststoensurethesecuritypleaseverifyitfirst:
    'sudah ada, untuk memastikan keamanannya silakan verifikasi terlebih dahulu.',
};

export default loginAndSignUp;
